/**
 * La pièce qui rejoint le compteur.
 *
 * Une tâche validée rapporte des pièces, et le compteur qui les montre est à
 * l'autre bout de l'écran (la pastille de la jauge du jour). Le chiffre
 * changeait en silence. Ici, une pièce part de la case et vole jusqu'à lui :
 * le lien entre le geste et ce qu'il rapporte se voit.
 *
 * Le compteur se déclare avec `data-coin-target`. Sans compteur visible (vue
 * de toute la famille, page défilée), il n'y a pas de vol : l'appelant garde
 * son retour à lui.
 */
import { eventBus } from '@/utils/eventBus'

/** Le compteur visible à l'écran, ou rien. */
export function coinTarget(): HTMLElement | null {
  if (typeof document === 'undefined') return null
  for (const el of Array.from(document.querySelectorAll<HTMLElement>('[data-coin-target]'))) {
    const r = el.getBoundingClientRect()
    if (r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight) return el
  }
  return null
}

/**
 * Fait partir une pièce du centre de `from`. Rend faux s'il n'y a pas de
 * compteur à rejoindre : l'appelant affiche alors son propre retour.
 */
export function requestCoinFlight(from: Element | null | undefined): boolean {
  if (!from || !coinTarget()) return false
  const r = from.getBoundingClientRect()
  eventBus.emit('app:coin-flight', { x: r.left + r.width / 2, y: r.top + r.height / 2 })
  return true
}
